// extracted by mini-css-extract-plugin
export default {"chat":"Chat_chat__BKQxE","messages":"Chat_messages__zji+E","action":"Chat_action__lAmfv"};